import { isBefore } from 'date-fns'

export class PlantasBloco {
  private readonly plantas: Array<{
    id: string
    descricao: string
  }>

  constructor(
    plantas: Array<{
      id: string
      descricao: string
    }>,
  ) {
    this.plantas = plantas
  }

  isDataAlvenariaAnteriorHoje(data?: string | null): boolean {
    if (!data) return false
    return isBefore(new Date(data), new Date(new Date().setHours(0, 0, 0, 0)))
  }

  getPrimeiraPlantaDoBloco(): Array<{
    id: string
    descricao: string
  }>[number] {
    return this.plantas[0]!
  }
}
